import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

interface ConsultantAvatarProps {
  imageSrc: string;
  name: string;
  className?: string;
}

export const ConsultantAvatar = ({ imageSrc, name, className }: ConsultantAvatarProps) => {
  const initials = name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase();

  return (
    <Avatar className={className}>
      <AvatarImage src={imageSrc} alt={`${name} - Professional Business Consultant`} loading="lazy" />
      <AvatarFallback className="bg-gradient-primary text-white text-2xl">
        {initials}
      </AvatarFallback>
    </Avatar>
  );
};
